import { render, staticRenderFns } from "./ConfigSmsRecipient.vue?vue&type=template&id=09722b02&scoped=true&"
import script from "./ConfigSmsRecipient.vue?vue&type=script&lang=js&"
export * from "./ConfigSmsRecipient.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSmsRecipient.vue?vue&type=style&index=0&id=09722b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09722b02",
  null
  
)

export default component.exports